import { createContext, useContext } from 'react';
import { RootStore } from './root.store';

export const appStoreContext = createContext(new RootStore());

export const useAppStore = (): RootStore => useContext(appStoreContext);
